import { IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import api from '../api/api';
import { generateRandomToken } from '../utils/stinggenerator';
import ToastMessage from '../utils/mui/righttoptoast';
import axios from 'axios';
import { UTILITY_BASE } from "../api/bases";
import { getPracticeId } from "../config/practice";
import { RESET_CALLER_MAILS, RESET_SENT_BY_SERVER, resetSentMessage } from "../auth/passwordReset";

const PasswordResetM = ({CloseResendModal,userData}) => {
   const [loading, setLoading] = useState(false);
   const [alertmessage, setAlertMessage] = useState('');
   const [severity, setSeverity] = useState('success');
   const [open, setOpen] = useState(false);
    const practiseid = getPracticeId();
  // Function to handle the API call for deleting the user
  console.log("No user ID provided!",userData);
  const handlealert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleReset = async (userData) => {
    if (!userData) {
        console.log("No user ID provided!");
      return;
    }

    setLoading(true); // Start loading

    try {
      const token = generateRandomToken(); // Generate the token
      const baseUrl = window.location.origin; // Dynamically gets the domain where the app is running
      const resetLink = `${baseUrl}/reset/${token}`;
      // Send the request to the forgot password API
      const response = await api.post(`/v1/${practiseid}/auth/forgot-password`, {
        "useremail": userData.email,
        "token": token  
      });
  
      // Email message with enhanced HTML UI
      const message = `
        <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #f9f9f9;">
          <h2 style="color: #555;">Password Reset Request</h2>
          <p style="font-size: 14px; line-height: 1.6;">Hi there,</p>
          <p style="font-size: 14px; line-height: 1.6;">
            We received a request to reset your password. Click the button below to reset it:
          </p>
          <a href="${resetLink}" 
            style="display: inline-block; padding: 10px 20px; margin: 10px 0; color: #fff; background-color: #007BFF; text-decoration: none; border-radius: 5px;">
            Reset Password
          </a>
          <p style="font-size: 14px; line-height: 1.6;">
            If you did not request this, you can safely ignore this email.
          </p>
          <p style="font-size: 14px; line-height: 1.6; margin-top: 20px;">
            Thanks,<br />
            The Team
          </p>
        </div>
      `;
  if (response.status === RESET_SENT_BY_SERVER) {
    // The gateway made the token and mailed the link itself; a second mail
    // would carry a token it never stored.
    setAlertMessage(resetSentMessage(response, "Password reset link sent."));
    setSeverity("success");
    setOpen(true);
    setLoading(false);
    setTimeout(() => CloseResendModal(), 2000);
    return;
  }
  if(response.status===RESET_CALLER_MAILS){
    const formData = new FormData();
formData.append("subject", "Reset password email");
formData.append("to", userData.email);
formData.append("message", message);
   const resp = await axios.post(`${UTILITY_BASE}/send-email`, formData, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
})
  
      if (resp.status === 200) {
        setAlertMessage('Password reset instructions sent to your email.');
        setSeverity('success');
        setOpen(true);
     setTimeout(() => {
          CloseResendModal()
          }, 2000);
        // Clear the fields and stop loading
     
        setLoading(false);
     
      }else if (resp.status === 201) {
        // If status is 201, show an error message
        setAlertMessage(' Unable to send the password reset email. Please try again later.');
        setSeverity('error');
        setOpen(true);
        setLoading(false);
      }else{
          setAlertMessage("Something went Wrong");
    setSeverity('error');
    setOpen(true);
      }
  }else{
    setAlertMessage("Something went Wrong");
    setSeverity('error');
    setOpen(true);
  

  }
      // Send the email with the reset link
     
    } catch (error) {
      setAlertMessage('Something went wrong');
      setSeverity('error');
      setOpen(true);
      console.log(error);
      setLoading(false); // Stop loading state in case of error
    }finally{
        setLoading(false);
    }
  };
  
  return (
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
      {/* Popup Box */}
      <div className="relative flex flex-col w-[30%] bg-white pb-2 p-3 rounded-lg shadow-lg text-left">
        <div className="flex justify-between items-center border-b pb-2">
          <h3 className="font-semibold text-lg">Are you sure?</h3>
          <IconButton onClick={CloseResendModal} className="text-gray-600 hover:text-gray-700">
            <CloseIcon fontSize="medium" />
          </IconButton>
        </div>
        <div className='p-2'>
        <h3 className="font-inter my-4 text-lg">You want to send Password Reset Link?</h3>

        </div>

        <div className="flex justify-end gap-2 mt-4">
          {/* Cancel Button */}
          <button
            onClick={CloseResendModal}
            className="py-2 px-4 bg-gray-100 rounded-lg text-gray-700 hover:bg-gray-200"
          >
            Cancel
          </button>

          {/* Yes Button - Delete User */}
          <button
            onClick={()=>handleReset(userData)}
            className={`py-2 px-4 bg-gray-400 text-white rounded-lg hover:bg-red-700`}
          >
            Send
          </button>
        </div>
      </div>
      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handlealert} />

    </div>
  )
}

export default PasswordResetM
